<template>
  <div>
    <div>
      <MultiLineChart
        :data="chartData"
        :legendHeaders="getGraphHeaders"
        :showLegend="true"
        :intervalTime="intervalTime"
        :chartId="getRandomUniqueId"
        :graphIndex="0"
        :title="graphConfig.title"
        :formula="getFormulaFromMapper"
        :Graphlabels="graphConfig.graphTitles"
        :loading="loading"
        @openModal="openGraphModal"
      />
    </div>
    <div>
      <MultiChartModal
        :showGraphModal="this.showGraphModal"
        :data="chartData"
        :infoSpanColIndex="1"
        :highLightColValue="0"
        :legendHeaders="getGraphHeaders"
        :showLegend="true"
        :formula="getFormulaFromMapper"
        :intervalTime="intervalTime"
        :chartId="getRandomUniqueId"
        :graphIndex="0"
        :title="graphConfig.title"
        :Graphlabels="graphConfig.graphTitles"
        :loading="loading"
        @openModal="openGraphModal"
        @onHide="showGraphModal = false"
        @closeGraphModal="showGraphModal = false"
      />
    </div>
  </div>
</template>

<script>
import MultiLineChart from '@/components/charts/multi-chart.vue';
import MultiChartModal from '@/components/charts/multi-chart-modal';
import { mapActions, mapGetters, mapState } from 'vuex';
import { getRandomUniqueId } from '@/utils/helper-function';
import { multilineGraphFormulaMapper } from '@/components/Home/utils/custom.home.types';

export default {
  components: {
    MultiLineChart,
    MultiChartModal,
  },
  name: 'MultilineGraphBuilder',
  props: {
    graphConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartData: [],
      loading: false,
      showGraphModal: false,
    };
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    getRandomUniqueId,
    getGraphHeaders() {
      try {
        return JSON.parse(this.graphConfig.header.content);
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    getFormulaFromMapper() {
      return multilineGraphFormulaMapper[this.graphConfig.formula];
    },
  },
  methods: {
    ...mapActions({
      getGraphDataForCustomDashboard(dispatch, payload) {
        return dispatch(
          `${this.graphConfig.actionPath}/getGraphDataForCustomDashboard`,
          payload,
        );
      },
    }),
    openGraphModal() {
      this.showGraphModal = true;
    },
    async fetchGraphData() {
      try {
        const labels = this.graphConfig.instanceIds.map(
          (instance) => instance.keyLabel,
        );
        this.loading = true; // Start loading
        const params = {
          duration: this.getDurationTime,
          chartConfig: this.graphConfig,
        };
        const response = await this.getGraphDataForCustomDashboard(params);

        this.chartData = response.map((item, idx) => ({
          ...item.readMetricsValues,
          label: labels[idx] || '',
        }));
      } catch (error) {
        console.error('Error fetching graph data:', error);
        // Handle error scenario as needed
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchGraphData();
  },
  watch: {
    getDurationTime() {
      this.fetchGraphData();
    },
  },
};
</script>
